
const digest = 'e82744858a3e9dccb1ef1f9c845aa11c9656a7cfbbc440f6716c3a612e5dc631';
const classes = {"wrapper":"_wrapper_4b7y9_1"};
const css = `._wrapper_4b7y9_1 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-family: Rubik, "sans-serif";
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  